import * as React from "react";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import PosRequestSearch from "./pos-request-search";
import PosRequestConfirm from "./pos-request-confirm";
import * as PosService from '../../Services/pos-service'
import PosRequestChangeContact from "./pos-request-change-contact";
import PosRequestChangePersonal from "./pos-request-change-personal";
import PosRequestChangeFrequency from "./pos-request-change-frequency";
import PosRequestUploadFile from "./pos-request-upload-file";
import PosRequestSuccessForm from "./pos-request-success-form";
import 'react-toastify/dist/ReactToastify.css';
import { CircularProgress } from "@mui/material";
import '../../Assets/Styles/Pos/pos-request.css';
import ImageBackground from '../../Assets/Images/background-contnt.png'
import CustomNav from '../../Components/custom-nav/CustomNav';
import FooterCustomer from '../../Layouts/footer/FooterCustomer';
import useWindowDimensions from "../../Layouts/useWindowDimension";
import { countTimeExpired } from "../../Services/service";
import PosRequestGuide from "./pos-request-guide";

function PosRequest({ t }) {
  const [objectDto, setObjectDto] = useState({});
  const [objectLocal, setObjectLocal] = useState(JSON.parse(localStorage.getItem('aaa')));
  const [loading, setLoading] = useState(false);
  const [listFile, setListFile] = useState([]);
  const [validate, setValidate] = useState(false);
  const [reset, setReset] = useState(false);
  const { height, width } = useWindowDimensions();
  const [activeItem, setActiveItem] = useState({ title: t("posrequestcustomer"), icon: <i class="fa fa-info-circle" aria-hidden="true"></i>, no: 4 });
  const divStyle = {
    backgroundImage: `url(${ImageBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100vw',
    height: height,
    backgroundRepeat: 'no-repeat'
  };
  countTimeExpired(objectDto, setObjectDto);
  PosService.ManagePosRequest(objectDto, setObjectDto, loading, setLoading, listFile);
  return (
    <>
      <div className='nav-container' style={{ height: height }}>
        <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectLocal} setObjectDto={setObjectLocal} width={width} height={height} />
        <div className="pos-info-container" style={divStyle}>
          <section className="payment-info-container" style={{ width: "95%", margin: "0 0 15% 2%" }}>
            <div className="row heading-phl" style={{ marginTop: "10px", marginBottom: "15px" }}>
              <div className="col-sm-12 col-xs-12 col-md-12" style={{ textAlign: "center" }} hidden={objectDto === undefined}>
                <label className="title-head-claim header-title-customer" style={{ textAlign: "center" }}>
                  {t('posrequest').toUpperCase()}
                </label>
              </div>
            </div>
            {
              objectDto !== undefined && objectDto !== null && objectDto !== '' ?
                <>
                  {/* Search saved == 0 */}
                  <PosRequestSearch objectDto={objectDto} reset={reset} setReset={setReset} setObjectDto={setObjectDto} setLoading={setLoading} lang={t} validate={validate} setValidate={setValidate} />
                  <PosRequestGuide />
                  {
                    objectDto.checked !== undefined && objectDto.saved !== undefined && (objectDto.checked === 1 || objectDto.saved === 1) ? (
                      <>
                        {/* Change Contact  */}
                        {
                          objectDto.changeContactChecked !== undefined && objectDto.changeContactChecked === 1 ?
                            <PosRequestChangeContact objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} lang={t} validate={validate} /> : ""
                        }

                        {/* Change Personal */}
                        {
                          objectDto.changePersonalChecked !== undefined && objectDto.changePersonalChecked === 1 ?
                            <PosRequestChangePersonal objectDto={objectDto} setObjectDto={setObjectDto} lang={t} /> : ""
                        }

                        {/* Change Frequency */}
                        {
                          objectDto.changeFrequencyChecked !== undefined && objectDto.changeFrequencyChecked === 1 ?
                            <PosRequestChangeFrequency objectDto={objectDto} lang={t} setObjectDto={setObjectDto} /> : ""
                        }
                        {/* Upload Files */}
                        {(objectDto.changePersonalChecked !== undefined && objectDto.changeFrequencyChecked !== undefined && objectDto.changePhoneChecked !== undefined && objectDto.changeFrequencyChecked === 1 || objectDto.changePersonalChecked === 1 || objectDto.changePhoneChecked === 1) ?
                          <PosRequestUploadFile objectDto={objectDto} setObjectDto={setObjectDto} setLoading={setLoading} listFile={listFile} setListFile={setListFile}
                            lang={t} validate={validate} /> : ""
                        }
                        {/* Confirm (Collapse last) checked === 1 */}
                        <PosRequestConfirm objectDto={objectDto} setLoading={setLoading} setObjectDto={setObjectDto} listFile={listFile}
                          setValidate={setValidate} />
                        {/* Success form saved === 1*/}
                        {objectDto.saved === 1 ?
                          (
                            <PosRequestSuccessForm setLoading={setLoading} setObjectDto={setObjectDto} lang={t} />
                          ) : ('')
                        }
                      </>
                    ) : ('')
                  }

                </>
                :
                <div style={{ textAlign: "center", paddingTop: "120px" }}>
                  <h3 style={{ color: "red", fontWeight: "bold" }}>{t("erroraccesspage").toUpperCase() + " "}<a style={{ "color": "#c4960c" }} href="/" >Về trang chủ</a></h3>
                  <CircularProgress style={{ color: "red", marginTop: "50px" }} />
                </div>
            }
          </section>
        </div>
      </div>
      <FooterCustomer />
    </>
  );
}
export default withTranslation()(PosRequest);